<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-29 16:48:16
 * @LastEditTime: 2019-08-29 16:48:16
 * @LastEditors: your name
 -->
<template>
    <div class="content" v-loading="loading">
        <div class="pageTitle">修改入库</div>
        <el-form ref="form" :rules="rules" :model="form" label-width="120px">
            <el-form-item label="入库单号:" prop="stock_in_sn">
                <el-col :span="8">
                    <el-input v-model="form.stock_in_sn" readonly class="readonlyclass"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="入库仓库:"  prop="warehouse_sn">
                <el-select clearable v-model="form.warehouse_sn" size="small">
                    <el-option v-for=" i in addArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                               :value="i.warehouse_sn"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="产品信息:"  prop="product_sn">
                <el-col :span="4">
                    <el-input v-model="form.product_sn"></el-input>
                </el-col>
                <el-col class="line" :span="1" style="text-align: center">-</el-col>
                <el-col :span="8">
                    <el-input v-model="form.product_name" readonly class="readonlyclass"></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 20px">
                    <el-button type="primary" @click="selectProduct()">选择</el-button>
                </el-col>
            </el-form-item>
            <el-form-item label="产品条码:">
                <el-col :span="8">
                    <el-input v-model="form.product_bar_code" readonly class="readonlyclass"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="生产批次号:">
                <el-col :span="8">
                    <el-input v-model="form.production_batch" ></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="生产日期">
                <el-col :span="8">
                    <el-date-picker type="date" placeholder="选择日期" v-model="form.production_date" style="width: 100%;" ></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="有效期至">
                <el-col :span="8">
                    <el-date-picker type="date" placeholder="选择日期" v-model="form.expiring_date" style="width: 100%;" ></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="数量:">
                <el-col :span="8">
                    <el-input v-model="form.stock_in_num" ></el-input>
                </el-col>
            </el-form-item>
           <!-- <el-form-item label="备注:">
                <el-col :span="8">
                    <el-input type="textarea" v-model="form.desc"></el-input>
                </el-col>
            </el-form-item>-->


            <el-form-item>
                <el-col :span="8">
                    <el-button type="primary" @click="save()">保存</el-button>
                    <!-- <el-button type="primary" @click="reset()">重置</el-button> -->
                   <!-- <el-button type="primary" @click="reset()">重置</el-button>-->
                </el-col>
            </el-form-item>

        </el-form>

        <selectProduct
                v-if="dialogVisible"
                v-on:handleClose = 'dialogVisible = false'
                v-on:pushData="getChildData"></selectProduct>
    </div>
</template>

<script>
    import selectProduct from './selectProduct.vue';
    export default {
        name: "editInstock",
        data () {
            return {
                loading:false,
                dialogVisible:false,
                form: {
                    stock_in_sn:'',
                    warehouse_sn:'',
                    product_sn:'',
                    product_name:'',
                    product_bar_code:'',
                    production_date:'',
                    expiring_date:'',
                    stock_in_num:'',
                },
                rules:{stock_in_sn:[
                            { required: true, message: '请输入入库单号', trigger: 'blur' },
                        ],
                        warehouse_sn:[
                            { required: true, message: '请选择入库单号', trigger: 'blur' },
                        ],
                        product_sn:[
                            { required: true, message: '请选择产品', trigger: 'blur' },
                        ]
                        },
                addArray:[],//仓库

            }
        },
        methods:{
            getStock(){
                this.$get('logistics','/warehouses.all', {
                    lang:''
                }).then(res => {
                    this.addArray = res.data;
                }).catch(function (error) {
                });
            },
            getChildData(val){
                this.form.product_bar_code = val.product_bar_code;
                this.form.product_sn = val.product_sn;
                this.form.product_name = val.product_name;
                this.form.product_category_id=val.product_category_id
                this.form.product_id=val.product_id

            },
            getData(){
                let url = '/inwarehouses/' + this.$route.query.stock_in_sn;
                this.$get('logistics',url, {
                }).then(res => {
                    this.form = res.data;
                }).catch(function (error) {
                });
            },
            save(){
                let beginstr = '', endstr = '';
                        if (this.form.production_date) {
                            beginstr = this.moment(this.form.production_date).format("YYYY-MM-DD")
                        }
                        if(this.form.expiring_date){
                             endstr = this.moment(this.form.expiring_date).format("YYYY-MM-DD");
                         }
                this.$refs.form.validate((valid) => {
                        if (valid) {
                            this.loading = true;
                let url = '/inwarehouses/' + this.$route.query.stock_in_sn;

                this.$put('logistics',url,{
                    _method:'PUT',
                    lang:'',
                    inwarehouse:this.$route.query.stock_in_sn,
                    warehouse_sn:this.form.warehouse_sn,
                    production_batch:this.form.production_batch,
                    product_bar_code:this.form.product_bar_code,
                    product_id:this.form.product_id,
                    product_sn:this.form.product_sn,
                    product_name:this.form.product_name,
                    stock_in_num:this.form.stock_in_num,
                    production_date:beginstr,
                    product_category_id:this.form.product_category_id,
                    expiring_date:endstr
                }).then(res => {
                    this.loading = false;
                    if(res.message == '操作成功'){
                       this.$message({
                           message: '修改成功',
                           type: 'success'
                       });
                       this.$router.push({
                           name:'instockManage'
                       });
                   }
                }).catch(error =>{
                    this.loading = false;
                    this.$message({
                        type: 'error',
                        message: error.message
                    });

                });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                        });

              

            },
            //重置
            reset(){
                this.getData();
            },
            selectProduct(){
                this.dialogVisible = true;
            }

        },
        created(){
            this.getStock();
            this.getData();
        },
        components:{
            selectProduct

        }
    }
</script>

<style lang="scss" scoped>


</style>